import {
  PERMISSIONS_REQUEST,
  PERMISSIONS_FAILURE,
  FETCH_PERMISSIONS_SUCCESS,
  CREATE_PERMISSIONS_SUCCESS,
  DELETE_PERMISSIONS_SUCCESS,
  UPDATE_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_SUCCESS,
} from "../action/types";

const initialState = {
  permissions: [],
  total: 0,
  currentPermission: null,
  loading: false,
  error: null,
};

const permissionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case PERMISSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        currentPermission: payload,
        permissions: state.permissions.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case CREATE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: [payload, ...state.permissions],
        total: state.total + 1,
      };

    case UPDATE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case PERMISSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default permissionReducer;
